import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";

export default function SearchNavigator({
  query,
  total,
  currentIndex,
  onPrev,
  onNext,
  onClear,
}) {
  if (!query) return null;

  return (
    <div className="fixed top-[110px] right-4 z-40 rounded-xl bg-white/90 dark:bg-slate-900/90 border border-slate-200 dark:border-slate-800 shadow px-3 py-2 flex items-center gap-2">
      <span className="text-sm tabular-nums">
        {total ? currentIndex + 1 : 0}/{total || 0}
      </span>
      <button
        className="p-1 rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-40"
        onClick={onPrev}
        disabled={!total}
        title="Résultat précédent"
      >
        <FiChevronLeft />
      </button>
      <button
        className="p-1 rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-40"
        onClick={onNext}
        disabled={!total}
        title="Résultat suivant"
      >
        <FiChevronRight />
      </button>
      <button
        className="p-1 rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
        onClick={onClear}
        title="Effacer la recherche"
      >
        <FiX />
      </button>
    </div>
  );
}
